export default {"src":"/developer/_next/static/media/failure.8ad098c9.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};